import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { ICreateDraftJobPostApiResponse } from '../types';

export const createDraftJobPost = async (): Promise<ICreateDraftJobPostApiResponse> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.post<ICreateDraftJobPostApiResponse>(
    '/posting-service/postings',
    {},
    { headers },
  );

  return response.data;
};
